// Prototyping action Type
export const POST_PROTOTYPING_UPLOAD_IMAGE = 'POST_PROTOTYPING_UPLOAD_IMAGE';
export const POST_PROTOTYPING_UPLOAD_IMAGE_SUCCESS = 'POST_PROTOTYPING_UPLOAD_IMAGE_SUCCESS';
export const POST_PROTOTYPING_UPLOAD_IMAGE_FAILURE = 'POST_PROTOTYPING_UPLOAD_IMAGE_FAILURE';